import styled from './menu.module.css';
import { CiHome, CiViewList, CiDollar, CiChat1, CiLogout, CiEdit, CiCalendar, CiRepeat, CiCamera } from 'react-icons/ci';
import { FaBars } from 'react-icons/fa'
import { useNavigate, Link } from 'react-router-dom';
import { useEffect, useState, useContext } from 'react';
import { AuthContext } from '../../services/global';
import api from '../../services/api';
import bannermenu from '../../assets/catalogomenu.jpg';
import menu1 from '../../assets/menu1.jpg';
import menu2 from '../../assets/menu2.jpg';
import menu3 from '../../assets/menu3.jpg';
import menu4 from '../../assets/menu4.jpg';
import menu5 from '../../assets/site_lateral.jpg';
import menu6 from '../../assets/taxa_lateral.jpg';
import menu7 from '../../assets/parcelar_lateral.jpg';


const images = [
    bannermenu,
    menu1,
    menu2,
    menu3,
    menu4,
    menu5,
    menu6,
    menu7
]

function Menu(props) {
    const login = JSON.parse(localStorage.getItem("login"));
    const cgccli = login.cgccli;
    const nomcli = login.nomcli;
    const imgcli = login.imgcli;
    const Navigate = useNavigate();
    const [menushow, setMenushow] = useState(false);
    const { setFiltro, setTipo } = useContext(AuthContext);
    const [currentIndex, setCurrentIndex] = useState(0);

    function ShowMenu() {
        setMenushow(!menushow);

    }



    function Remclasses() {
        const element = document.querySelector('#main');
        element.classList.remove(styled.itemactive);

        const element1 = document.querySelector('#pedidos');
        element1.classList.remove(styled.itemactive);

        const element6 = document.querySelector('#assistencia');
        element6.classList.remove(styled.itemactive);

        const element2 = document.querySelector('#financeiro');
        element2.classList.remove(styled.itemactive);

        const element3 = document.querySelector('#avaliacao');
        element3.classList.remove(styled.itemactive);

        const element4 = document.querySelector('#dados');
        element4.classList.remove(styled.itemactive);

        const element5 = document.querySelector('#contatos');
        element5.classList.remove(styled.itemactive);

        const element7 = document.querySelector('#catalogo');
        element7.classList.remove(styled.itemactive);
    }

    async function VisitaPage() {
        await api.post(`visita/?cgccli=${cgccli}&page=Catalogo`)
            .then((response) => {


            }).catch((erro) => {

            })
    }



    function classes(wclasse) {
        if (wclasse === 'catalogo')
        {
            window.open('https://catalogo.cozimax.com.br' ,"_blank","noopener noreferrer");
        }else{
           Navigate('/' + wclasse);
        }
        
        

        Atualiza(wclasse);
        setFiltro('Todos');
        setTipo('3');

        if (wclasse == 'catalogo') {
            VisitaPage();
        }

    }

    function Atualiza(wclasse) {
        Remclasses();
        const welement = document.querySelector('#' + wclasse);
        welement.classList.add(styled.itemactive);
    }

    function OpenBanner() {
    if (currentIndex === 0){
    VisitaPage();
    window.open('https://catalogo.cozimax.com.br' ,"_blank","noopener noreferrer");}
     if (currentIndex === 2){
       window.open(`https://wa.me/5517991236900`,'_blank') 
    }
    if (currentIndex === 5){
       window.open(`https://cozimax.com.br`,'_blank')  
    }
  }

    useEffect(() => {
        Atualiza(props.menu);
        if (menushow == true) {
            document.body.classList.add(styled.add)
            document.body.classList.remove(styled.remove)
        } else {
            document.body.classList.add(styled.remove)
            document.body.classList.remove(styled.add)
        }

        const interval = setInterval(() => {
            setCurrentIndex((prev) => (prev + 1) % images.length);
        }, 7000);

        return () => clearInterval(interval); // limpa ao desmontar
    }, [menushow])


    return (
        <>
            <div className={styled.appmenu}>
                <div className={styled.logo}></div>
                <FaBars className={styled.sidebar} onClick={() => ShowMenu()} />

                <div className={styled.menucontent}>
                    <div className={styled.menulist}>
                        <div id="main" className={styled.item} onClick={() => classes('main')}>
                            <CiHome className={styled.menuicon} />
                            <a>Página Inicial</a>
                        </div>
                        <div id="pedidos" className={styled.item} onClick={() => classes('pedidos')}>
                            <CiViewList className={styled.menuicon} />
                            <a>Pedidos</a>
                        </div>
                        <div id="assistencia" className={styled.item} onClick={() => classes('assistencia')}>
                            <CiRepeat className={styled.menuicon} />
                            <a>Assistências</a>
                        </div>
                        <div id="financeiro" className={styled.item} onClick={() => classes('financeiro')}>
                            <CiDollar className={styled.menuicon} />
                            <a>Financeiro</a>
                        </div>
                        <div id="avaliacao" className={styled.item} onClick={() => classes('avaliacao')}>
                            <CiChat1 className={styled.menuicon} />
                            <a>Avaliações</a>
                        </div>
                        <div id="dados" className={styled.item} onClick={() => classes('dados')}>
                            <CiEdit className={styled.menuicon} />
                            <a>Dados da Empresa</a>
                        </div>
                        <div id="contatos" className={styled.item} onClick={() => classes('contatos')}>
                            <CiCalendar className={styled.menuicon} />
                            <a>Contatos</a>
                        </div>
                        <div id="catalogo" className={styled.item} onClick={() => classes('catalogo')}>
                            <CiCamera className={styled.menuicon} />
                            <a>Catálogo Digital</a>
                        </div>
                        <div className={styled.item}>
                            <CiLogout className={styled.menuicon} />
                            <Link to='/'>Sair</Link>
                        </div>
                    </div>
                </div>
                <div className={styled.menuusuario}>
                    <div className={styled.grupousuario}>
                        {imgcli ?
                            <img src={imgcli} className={styled.imgusuario} /> :
                            null
                        }
                        <a>{nomcli}</a>
                        <span>{cgccli}</span>
                    </div>
                </div>
                <div className={styled.banner}>
                    <img src={images[currentIndex]}
                        alt="Carrossel"
                        style={{
                            width: "100%",
                            height: "100%",
                            //objectFit: "cover",
                            borderRadius: "3px",
                            transition: "opacity 0.5s ease"


                        }} onClick={() => OpenBanner()}></img>


                </div>
            </div>

            {menushow == true ?
                <div className={styled.fundo} onClick={() => ShowMenu()}>
                    <div className={styled.menumobile}>
                        <div className={styled.logo}></div>
                        <div className={styled.menulist}>
                            <div id="main" className={styled.item} onClick={() => classes('main')}>
                                <CiHome className={styled.menuicon} />
                                <a>Página Inicial</a>
                            </div>
                            <div id="pedidos" className={styled.item} onClick={() => classes('pedidos')}>
                                <CiViewList className={styled.menuicon} />
                                <a>Pedidos</a>
                            </div>
                            <div id="assistencia" className={styled.item} onClick={() => classes('assistencia')}>
                                <CiRepeat className={styled.menuicon} />
                                <a>Assistências</a>
                            </div>
                            <div id="financeiro" className={styled.item} onClick={() => classes('financeiro')}>
                                <CiDollar className={styled.menuicon} />
                                <a>Financeiro</a>
                            </div>
                            <div id="avaliacao" className={styled.item} onClick={() => classes('avaliacao')}>
                                <CiChat1 className={styled.menuicon} />
                                <a>Avaliações</a>
                            </div>
                            <div id="dados" className={styled.item} onClick={() => classes('dados')}>
                                <CiEdit className={styled.menuicon} />
                                <a>Dados da Empresa</a>
                            </div>
                            <div id="contatos" className={styled.item} onClick={() => classes('contatos')}>
                                <CiCalendar className={styled.menuicon} />
                                <a>Contatos</a>
                            </div>
                            <div className={styled.item}>
                                <CiLogout className={styled.menuicon} />
                                <Link to='/'>Sair</Link>
                            </div>
                            <div className={styled.menuusuariomob}>
                                <div className={styled.grupousuariomob}>
                                    {imgcli ?
                                        <img src={imgcli} className={styled.imgusuariomob} /> :
                                        null
                                    }
                                    <a>{nomcli}</a>
                                    <span>{cgccli}</span>
                                </div>
                            </div>
                        </div>


                    </div>
                </div> : null}

        </>
    )
}


export default Menu;